(function () {
  'use strict';
  var S = 44;
  function reduced() {
    try {
      return matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }
  function cartImg(o) {
    if (!o) return '';
    if (o.image) return o.image;
    var it = o.items;
    return it && it.length ? it[it.length - 1].image || '' : '';
  }
  function preview(pf) {
    var root =
      pf &&
      (pf.closest('.wbproduct-container,.card-wrapper,.product-card-wrapper,.product') || pf);
    var img = root && root.querySelector('.product__media-item img,.wbimgblock img,img[src]');
    return img ? img.currentSrc || img.src || '' : '';
  }
  function rect(form, opener) {
    var btn =
      form &&
      (form.querySelector('button[name="add"][type="submit"]') ||
        form.querySelector('button.product-form__submit[type="submit"]') ||
        form.querySelector('[type="submit"]'));
    var el = btn || (form && form.querySelector('.product-form__buttons')) || opener || form;
    if (!el || !el.getBoundingClientRect) return null;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return null;
    return { left: r.left, top: r.top, width: r.width, height: r.height };
  }
  function patchIcon(st) {
    var html = st.sections && st.sections['cart-icon-bubble'];
    if (!html) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (inner) el.innerHTML = inner.innerHTML;
  }
  function css() {
    var id = 'cart-fly-to-cart-s',
      t =
        '.cart-fly-to-cart{--offset-y:10px;position:fixed;left:0;top:0;width:var(--fly-w,44px);height:var(--fly-h,44px);z-index:2147483646;pointer-events:none;border-radius:50%;overflow:hidden;box-shadow:0 4px 18px rgba(0,0,0,.14);opacity:1;translate:var(--start-x,0) var(--start-y,0);transform:translate(-50%,-50%);will-change:translate,transform;animation-name:cart-fly-x,cart-fly-y,cart-fly-scale;animation-timing-function:var(--x-timing),var(--y-timing),var(--scale-timing);animation-duration:var(--fly-duration,.75s);animation-delay:0,var(--fly-y-delay,0),0;animation-composition:accumulate;animation-fill-mode:both}.cart-fly-to-cart--main{--x-timing:cubic-bezier(.62,-.22,.88,.5);--y-timing:cubic-bezier(.42,0,.58,1);--fly-y-delay:.11s;--scale-timing:cubic-bezier(.85,.05,.96,1);--fly-duration:.75s}.cart-fly-to-cart--sticky{--x-timing:cubic-bezier(.88,-.2,.92,.5);--y-timing:cubic-bezier(.4,0,.6,1);--fly-y-delay:.13s;--scale-timing:cubic-bezier(.86,.08,.98,.98);--fly-duration:.9s}@keyframes cart-fly-x{to{translate:var(--travel-x,0) 0}}@keyframes cart-fly-y{to{translate:0 var(--travel-y,0)}}@keyframes cart-fly-scale{0%{opacity:1}5%{opacity:1}100%{opacity:1;transform:translate(-50%,calc(-50% + var(--offset-y))) scale(.22)}}.cart-fly-to-cart img{width:100%;height:100%;object-fit:cover;border-radius:50%}',
      e = document.getElementById(id);
    if (e) e.textContent = t;
    else {
      e = document.createElement('style');
      e.id = id;
      e.textContent = t;
      document.head.appendChild(e);
    }
  }
  function flyDurationMs(box) {
    return box.classList.contains('cart-fly-to-cart--sticky') ? 900 : 750;
  }
  function isStickyHeader() {
    var h = document.querySelector('.section-header');
    return !!(h && (h.classList.contains('shopify-section-header-sticky') || h.classList.contains('cart-drawer-pinned')));
  }
  function cartIconRect() {
    var target = document.querySelector('#cart-icon-bubble');
    if (!target) return null;
    var r = target.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 ? r : null;
  }
  function syncHeaderHeight() {
    var sticky = document.querySelector('sticky-header');
    if (sticky && typeof sticky.syncHeaderHeightForCartFly === 'function') {
      sticky.syncHeaderHeightForCartFly();
    }
  }
  function fly(from, url, done) {
    css();
    var size = Math.min(52, Math.max(S, Math.round(Math.min(from.width, from.height) * 0.55) || S)),
      box = document.createElement('div');
    box.className = 'cart-fly-to-cart';
    box.classList.add(isStickyHeader() ? 'cart-fly-to-cart--sticky' : 'cart-fly-to-cart--main');
    box.setAttribute('aria-hidden', 'true');
    box.style.setProperty('--fly-w', size + 'px');
    box.style.setProperty('--fly-h', size + 'px');
    if (url) {
      var im = document.createElement('img');
      im.alt = '';
      im.src = url;
      box.appendChild(im);
    } else {
      box.style.background = 'rgb(var(--color-background))';
    }
    var startX = from.left + from.width / 2,
      startY = from.top + from.height / 2;
    box.style.animation = 'none';
    document.body.appendChild(box);
    var run = function () {
      var tr = cartIconRect();
      if (!tr) {
        box.remove();
        return done();
      }
      var endX = tr.left + tr.width / 2,
        endY = tr.top + tr.height / 2,
        finished = false,
        end = function () {
          if (finished) return;
          finished = true;
          box.remove();
          done();
        };
      box.style.setProperty('--start-x', startX + 'px');
      box.style.setProperty('--start-y', startY + 'px');
      box.style.setProperty('--travel-x', endX - startX + 'px');
      box.style.setProperty('--travel-y', endY - startY + 'px');
      void box.offsetWidth;
      box.style.animation = '';
      var ms = flyDurationMs(box);
      box.addEventListener(
        'animationend',
        function (e) {
          if (e.animationName === 'cart-fly-scale') end();
        },
        { once: true }
      );
      setTimeout(end, ms + 80);
    };
    requestAnimationFrame(function () {
      requestAnimationFrame(run);
    });
  }
  function play(o) {
    var d = o.cartDrawer,
      st = o.parsedState,
      pf = o.productForm,
      openDrawer = o.openDrawer !== false,
      done = function () {
        try {
          if (openDrawer && typeof d.open === 'function') d.open();
          o.onFlyComplete && o.onFlyComplete();
        } catch (e) {
          console.error(e);
        }
      };
    if (!d || !d.renderContents) return done();
    if (typeof d.setHeaderStickyForDrawer === 'function') d.setHeaderStickyForDrawer(true);
    var from = rect(pf, o.quickAddOpener),
      url = preview(pf) || cartImg(st);
    patchIcon(st);
    syncHeaderHeight();
    if (reduced() || !from) {
      d.renderContents(st, { openDrawer: false });
      return queueMicrotask(done);
    }
    d.renderContents(st, { openDrawer: false });
    syncHeaderHeight();
    fly(from, url, done);
  }
  window.ThemeCartFlyToCart = { play: play };
})();
